export function gtag() {
  
const node = document.getElementById('analitycs');
const {
  enable_ga,
} = JSON.parse(node.getAttribute('data'));
    
console.log(enable_ga);
if (enable_ga  === 'true')  {
	 console.log("gtag enabled")	
    dataLayer.push(arguments);
  } else {
    console.log("gtag call suppressed: tracking is disabled.");
    return null;	
  }
}
export const getRequestFlowPageTitle = (isContinuation, step) =>
  `${isContinuation ? 'COS' : 'New Request'} - ${step}`;

// Errors
export const sendAnalyticsError = (pageTitle, errorMessage) => {
  gtag('event', 'client_error', {
    page_title: pageTitle,
    error_message: errorMessage,
  });
};

export const formatErrorMessageWithCode = (code, message) => 
  code && message ? `${code} - ${message}` : message || code;

// Timing
export const sendAnalyticsTiming = (pageTitle, duration) => {
  gtag('event', 'user_time', {
    page_title: pageTitle,
    engagement_time_msec: duration,
    duration,
  });
}

// Click
export const sendAnalyticsClick = (clickedElement) => {
  gtag('event', 'click', {
    clicked_element: clickedElement,
  });
}